<template>
  <div class='lt-scene_shelf'>
    <SceneItemTransition :isActive="holiday === 3">
      <img
        src='../../assets/holiday-3.svg'
        class='lt-scene_cupboard_holiday'
        alt=""
      />
    </SceneItemTransition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import SceneItemTransition from '../../components/SceneItemTransition';

export default {
  components: {
    SceneItemTransition,
  },
  computed: {
    ...mapFields([
      'scene.status.holiday',
    ]),
  },
};
</script>

<style lang='scss'>
$img-base: '../../assets';

$shelf-height: 129;
$shelf-width: 182;

.lt-scene_shelf {
  position: absolute;
  right: 0;
  top: proportionSize(206, $scene-height);
  width: proportionSize($shelf-width, $scene-width);
  height: proportionSize($shelf-height, $scene-height);
  background: transparent url("#{$img-base}/shelf.svg") no-repeat top right;

  .lt-scene_cupboard_holiday {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(-100%);
    width: proportionSize(166, $shelf-width);
  }
}

</style>
